import PocketBase from "pocketbase";
import { API_BASE_URL, pb } from "./pocketbaseConfig";

// Keep SDK error/pagination/auth handling, but send network calls to the worker.
// This client shares only the existing local session store, never admin credentials.
const workerClient = new PocketBase(`${API_BASE_URL}/worker-api`, pb.authStore);
workerClient.autoCancellation(false);
workerClient.beforeSend = (url, options) => {
  const target = new URL(url);
  const match = target.pathname.match(
    /\/worker-api\/api\/collections\/([^/]+)\/(records(?:\/[^/]+)?|[^/]+)$/,
  );
  if (!match) throw new Error("Unsupported worker API request.");
  const [, collection, action] = match;
  target.pathname = action === "records" || action.startsWith("records/")
    ? `/worker-api/records/${collection}${action.slice("records".length)}`
    : `/worker-api/auth/${collection}/${action}`;
  return { url: target.toString(), options };
};

export function apiRecords(collection: string) {
  return workerClient.collection(collection);
}
